import React from 'react';
import posthog from 'posthog-js';
import { useStore } from '../../../../store';
import { isUserLoggedIn } from '../../../../utils/analytics';
import CTASection from '../../../../ui/organisms/CTASection';

const LaunchCampaignCTASection: React.FC = () => {
  const { state } = useStore();

  const handleCtaClick = () => {
    posthog.capture('home_launchCampaignCTA_click', {
      is_logged_in: isUserLoggedIn(state.user),
      link_href: '/launch-campaign',
    });
  };

  return (
    <div className="mt-10 mb-10">
      <CTASection
        heading="Ready to Launch Your Own Drop with Makeship?"
        subheading={`Made by fans, for fans. We create merch that brings your story to life; partnering with you to design, make, promote, and sell every drop.\n\nRisk-free, cost-free, all Made with Makeship©.`}
        ctaText="Learn More"
        href="/launch-campaign"
        imgSrc="/assets/creators.png"
        onCtaClick={handleCtaClick}
      />
    </div>
  );
};

export default LaunchCampaignCTASection;
